import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { userDetailModel } from '../../features/organizations/organization.interface';

@Injectable({
  providedIn: 'root',
})
export class ReturnUrlService {
  private readonly DASHBOARD_URL = '/dashboard';
  private readonly ACTIVITY_DASHBOARD_URL = '/activity-dashboard';
  private readonly STORAGE_KEY = 'returnUrl';
  userData: userDetailModel | null = null;

  constructor(private readonly authService: AuthService) {
    this.authService.userData$.subscribe(data => {
      this.userData = data;
    });
  }

  private getDashboardUrl(): string {
    const userData = this.userData;
    return userData?.isSuperAdmin
      ? this.ACTIVITY_DASHBOARD_URL
      : this.DASHBOARD_URL;
  }

  setReturnUrl(url: string | null): void {
    const userData = this.userData;
    if (userData && url && this.isValidReturnUrl(url)) {
      localStorage.setItem(this.STORAGE_KEY, decodeURIComponent(url));
    }
  }

  getReturnUrl(): string {
    return localStorage.getItem(this.STORAGE_KEY) || this.getDashboardUrl();
  }

  clearReturnUrl(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  private isValidReturnUrl(url: string): boolean {
    return url !== '/login' && url !== '/verify-user' && url.startsWith('/');
  }
}
